import WebRedirectDisplayResponse from "../models/web_redirect_display_response";

export default class WebRedirectDisplayState {
    isLoading: boolean = true;
    response?: WebRedirectDisplayResponse;
    errorMessage?: string;
}